import { ROUTE_HOME } from '@shared';

export { ROUTE_HOME };
export const routeHome = () => ({ type: ROUTE_HOME });
